import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { getBaseTheme } from '@Themes';

export const StyledLink = styled(Link)`
    text-decoration: none;
    color: ${getBaseTheme().colors.control.default.foregroundColor};
    display: block;
    padding: ${getBaseTheme().spaces.default.xs} ${getBaseTheme().spaces.default.m};
    line-height: ${getBaseTheme().texts.sizes.m.lineHeight};
    font-size: ${getBaseTheme().texts.sizes.m.fontSize};
`;

export const StyledLinkName = styled.div`
    button {
        margin-left: ${getBaseTheme().spaces.default.s};
        color: ${getBaseTheme().colors.control.focus.complementaryForegroundColor} !important;
        i {
            color: ${getBaseTheme().colors.control.focus.complementaryForegroundColor} !important;
        }
    }
`;

export const StyledLinkDesc = styled.div`
    font-size: ${getBaseTheme().texts.sizes.s.fontSize};
    color: ${getBaseTheme().colors.control.focus.complementaryForegroundColor};
`;

export const MenuItem = styled.li`
    font-size: ${getBaseTheme().texts.sizes.m.fontSize};
    font-weight: ${props => (props.noBold ? '400' : 'bold')};
    margin: 0 -${getBaseTheme().spaces.default.xs};
    &:hover {
        background-color: ${getBaseTheme().colors.control.hover.backgroundColor};
    }
    &:active,
    &.active {
        background-color: ${getBaseTheme().colors.control.active.backgroundColor};
    }
`;
